import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React from 'react';

type HomeLocationIconProps = SvgIconProps;

export const HomeLocationIcon: React.FC<HomeLocationIconProps> = props => (
  <SvgIcon width="16" height="16" viewBox="0 0 32 32" fill="none" {...props}>
    <path d="M28.16,12.25l-11.5-10a1,1,0,0,0-1.32,0l-11.5,10A1,1,0,0,0,4.5,14h23a1,1,0,0,0,.66-1.75ZM7.17,12,16,4.33,24.83,12Z" />
    <path d="M25,15H7a1,1,0,0,0-1,1V29a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V23h6v6a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V16A1,1,0,0,0,25,15ZM24,28H21V22a1,1,0,0,0-1-1H12a1,1,0,0,0-1,1v6H8V17H24Z" />
  </SvgIcon>
);
